<template>
  <div>
    <label
      :for="id"
      class="flex items-center gap-4 justify-between bg-secondary-container rounded-full px-3 py-2 cursor-pointer border-2 border-dashed border-transparent transition-colors duration-300 hover:transition-colors hover:duration-300 hover:border-primary"
    >
      <div class="flex fill-primary gap-2 items-center px-1 truncate">
        <Icon name="attach-file" class="shrink-0" />
        <p v-if="files.length > 0" class="label-lg truncate">
          {{ files.length }} archivo{{ files.length === 1 ? '' : 's' }}
          <span v-if="showFileSize">({{ formatBytes(totalFileSize) }})</span>
        </p>
        <p v-else class="body-md sm:body-lg truncate">
          Haz click para agregar tu{{ multiple ? 's archivos' : ' archivo' }}
        </p>
      </div>
      <ButtonIcon class="btn-filled fill-on-primary" icon="file-upload" />
    </label>
    <div
      v-if="maxFileSize && totalFileSize > maxFileSize"
      class="flex gap-2 items-center text-left text-error body-md px-4 py-2 sm:body-lg"
    >
      <Icon name="error" class="fill-error shrink-0" />
      <span>El tamaño máximo admitido es de {{ formatBytes(maxFileSize) }}</span>
    </div>
    <ul v-if="files.length" class="px-4">
      <li
        v-for="(file, key) in files"
        :key="key"
        class="flex justify-between items-center text-left body-md p-2 border-b border-dashed"
      >
        <span> {{ file.name }} {{ showFileSize ? `(${formatBytes(file.size)})` : '' }} </span>

        <ButtonIcon
          class="btn-text cursor-pointer fill-neutral40 hover:fill-error"
          @click="deleteFile(key)"
        >
          <Icon name="close" class="h-[18px] w-[18px]" />
        </ButtonIcon>
      </li>
    </ul>
    <input
      :id="id"
      name="id"
      type="file"
      v-bind="$attrs"
      ref="input"
      class="opacity-0"
      :multiple="multiple"
      @input="onFileInput"
    />
  </div>
</template>

<script>
import Icon from '@/Components/Icon'
import ButtonIcon from '@/Components/ButtonIcon'
export default {
  name: 'FormInputFile',
  inheritAttrs: false,
  components: {
    ButtonIcon,
    Icon,
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    maxFileSize: {
      // Maximum file size allowed in Bytes
      type: Number,
    },
    showFileSize: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { id: null, files: [] }
  },
  computed: {
    totalFileSize() {
      return this.files.reduce((accumulator, file) => (accumulator += file.size), 0)
    },
  },
  watch: {
    files: {
      deep: false,
      handler(value) {
        this.$emit('update-files', value)
      },
    },
  },
  mounted() {
    this.id = this._uid
  },
  methods: {
    onFileInput($event) {
      if (this.multiple) this.files.push(...$event.target.files)
      else this.files = [...$event.target.files]
    },
    deleteFile(key) {
      this.files.splice(key, 1)
    },
    formatBytes(bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes'

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
  },
}
</script>

<style></style>
